import script from "./Workflows.vue?vue&type=script&setup=true&lang=js"
export * from "./Workflows.vue?vue&type=script&setup=true&lang=js"

import "./Workflows.vue?vue&type=style&index=0&id=5524a6d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5524a6d6"]])

export default __exports__